// extracted by mini-css-extract-plugin
module.exports = {"root":"NoServices_root__tEY3S","title":"NoServices_title__d_K9S"};